// Speeds
export const $speedP1: number = 0.3
export const $speedP2: number = 0.6
export const $speedP3: number = 0.9

// Eases
export const easeInExpo: Array<number> = [0.7, 0, 0.84, 0]
export const easeOutExpo: Array<number> = [0.16, 1, 0.3, 1]
export const easeInOutExpo: Array<number> = [0.87, 0, 0.13, 1]
